import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getAttachmentText } from '../../actions/AttachmentsActions';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getAppSettingsByKey } from '../../selectors/AppConfigsSelectors';
import { checkTrue, isOCRFileTypeAllowed } from '../../utils/commonUtils';

const useStyles = makeStyles({
  buttonStyle: {
    marginRight: 10,
  },
});

const ScanTextButton = ({ attachmentId, extension, disabled = false }) => {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const classes = useStyles();

  const ocrEnabledFlag = useSelector(getAppSettingsByKey('OCR/Enabled'));
  const supportedExtensions = useSelector(getAppSettingsByKey('OCR/FileExtensions'));

  const showButton =
    !!attachmentId &&
    checkTrue(ocrEnabledFlag) &&
    isOCRFileTypeAllowed(supportedExtensions, extension);

  const downloadAttachmentText = async () => {
    await dispatch(getAttachmentText({ attachmentId }));
  };

  return (
    showButton && (
      <Button
        className={classes.buttonStyle}
        variant="secondary"
        disabled={disabled}
        onClick={downloadAttachmentText}
      >
        {translateString('Scan for Text')}
      </Button>
    )
  );
};

export default ScanTextButton;
